import { ERpaProcessStatus } from "src/app/calendar/interfaces/tipo-sesion";

/* eslint-disable no-unused-vars */
export interface IRequestObj {
  idRegistroEliminacion?: number;
  nombreSesion: string;
  idSesionCalendario: number;
  idPlaneacionCurso: number;
  idUsuarioAutoriza: number;
  idUsuarioSolicita: number;
  comentarios?: string;
  idEstatusEliminacion: RequestStatusOptions;
  fechaSolicita?: Date;
  fechaAutoriza?: Date;
  fechaInicioSesion: Date;
}
export interface IRequestObjBack extends IRequestObj {
  nombreUsuarioSolicita: string;
  nombreUsuarioAutoriza: string;
  idProcesoRpa?: ERpaProcessStatus;
}

export interface IChangeReqStatusBody {
  IdRegistroEliminacion: number;
  idEstatusEliminacion: number;
  comentarios: string;
}

export type SortOrderType = "asc" | "desc" | null;

export type SortType = "status" | "name" | null;

export enum RequestStatusOptions {
  accepted = 1,
  rejected = 2,
  pending = 3,
}

export type RequestActionType = "accept" | "reject";
